module.exports = __webpack_public_path__ + "img/jypx.06661b9b.png";